import {get, post, postJson} from './axios'

// 系统批次短信效果分析

// const RESOURCE_BASE_PATH = '/jd-yusms'
const RESOURCE_BASE_PATH = '/sms/marketing'

// 营销效果分析客户详情
export const getDetailCustomer = p => get(`${RESOURCE_BASE_PATH}/detail/customer`, p);

// 营销效果分析订单详情
export const getDetailOrder = p => get(`${RESOURCE_BASE_PATH}/detail/order`, p);

// 营销效果分析商品详情
export const getDetailWare = p => get(`${RESOURCE_BASE_PATH}/detail/ware`, p);

// 获取营销效果分析
export const getEffectAnalyze = p => get(`${RESOURCE_BASE_PATH}/effect/analyze`, p);

// 查询营销效果分析列表
export const getEffectPage = p => get(`${RESOURCE_BASE_PATH}/page`, p);

// 获取官方效果分析详情
export const getOfficialData = p => get(`${RESOURCE_BASE_PATH}/effect/analyze/official`, p);

//导出处理
export const exportMarketing = p => get(`/sms/marketing/effect/analyze/official/select/export?${p}`);

//导出处理
export const getEffectPreAutoTaskList = p => get(`${RESOURCE_BASE_PATH}/getEffectPreAutoTaskList`, p);

//获取营销数据总览
export const summaryV2Data = p => get(`/sms/marketing/effect/analyze/official/summaryV2`, p);

//汇总导出数据接口
export const summaryExport = p => get(`/sms/marketing/effect/analyze/official/summaryV2/export`, p);

export const summaryExport1 = p => get(`/sms/marketing/effect/analyze/official/export`,p);

//单批次短信效果分析，活动批次
export const getSelectBatch = p => get(`/sms/marketing/effect/analyze/official/getSelectBatch`, p);

//效果汇总字段设置查询接口
export const fieldJsonConfig = p => get(`/sms/marketing/fieldJsonConfig/query`, p);

//效果汇总字段设置接口
export const fieldJsonConfigSave = p => postJson('/sms/marketing/fieldJsonConfig/save', p); 

//短信营销数据总览详情接口
export const summaryDetail = p => get(`/sms/marketing/effect/analyze/official/activity/summary`, p);

//营销数据总览-商品分析
export const getAnalyzesku = p => get(`/sms/marketing/effect/analyze/sku`, p);

